export enum AlertBannerMode {
  MissingMarketQuoteFileLabel = 'MissingMarketQuoteFileLabel',
  MissingMarketQuoteOrRenewalPolicyFileLabel = 'MissingMarketQuoteOrRenewalPolicyFileLabel',
  MissingPolicySpecimenFileLabel = 'MissingPolicySpecimenFileLabel',
  MissingMarketBinderFileLabel = 'MissingMarketBinderFileLabel',
  MissingMarketPolicyFileLabel = 'MissingMarketPolicyFileLabel',
}
